import { UseFormWatch } from 'react-hook-form';

import { QuoteProduct, QuoteProductStatus, UnitsType } from 'app/api/quotes';
import { currencyFormat } from 'utils/currencyFormat';
import { QuoteTableFormData } from '../types';

interface UseDiscussionTotalProps {
  data: QuoteProduct[];
  watch: UseFormWatch<QuoteTableFormData>;
}

export const useDiscussionTotal = ({ watch }: UseDiscussionTotalProps) => {
  const quotes = watch('quotes');

  const totalAmount: { [unit in UnitsType]?: number } = quotes.reduce(
    (acc: { [unit in UnitsType]?: number }, { amount, amountType, status }) => {
      const currentAmount: number = status === QuoteProductStatus.AVAILABLE ? amount : 0;
      if (status === QuoteProductStatus.AVAILABLE) {
        return {
          ...acc,
          [amountType]: (acc[amountType] || 0) + currentAmount,
        };
      }
      return acc;
    },
    {},
  );
  const totalAmounts = Object.entries(totalAmount).map(([unit, amount]) => ({
    unit: unit as UnitsType,
    amount,
  }));

  const totalPrice = currencyFormat(
    quotes.reduce((acc, val) => {
      const singlePrice = val?.acceptedPrice ? Number(val?.acceptedPrice) : Number(val?.price);

      if (!Number.isNaN(singlePrice)) {
        const currentCount = val?.status === QuoteProductStatus.AVAILABLE ? val?.amount : 0;

        return acc + singlePrice * Number(currentCount);
      }

      return acc;
    }, 0) || 0,
  );

  return { totalPrice, totalAmounts };
};
